"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _default = {
  PropTypes: {
    src: _propTypes.default.string.isRequired,
    imageHeight: _propTypes.default.string.isRequired,
    imageWidth: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    subText: _propTypes.default.string.isRequired,
    isZeroResult: _propTypes.default.bool.isRequired,
    viewPort: _propTypes.default.string,
    buttonText: _propTypes.default.string,
    emptyStateLoader: _propTypes.default.shape({
      source: _propTypes.default.string,
      destination: _propTypes.default.string
    }),
    handleClick: _propTypes.default.func,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    showButton: _propTypes.default.bool,
    fontWeight: _propTypes.default.string
  },
  defaultProps: {
    src: 'https://images.trvl-media.com/hotels/2000000/1830000/1823800/1823707/64563298_z.jpg',
    imageHeight: '221px',
    imageWidth: '168px',
    text: 'Bold text',
    subText: 'not bold text',
    isZeroResult: true,
    buttonText: 'Edit Search',
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    showButton: false,
    fontWeight: 'bold'
  }
};
exports.default = _default;